import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#303030",
      "stroke-width": "2",
      d: "m11.414.707-10 10 10 10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-opacity": ".2",
      "stroke-width": "2",
      d: "m11.414.707-10 10 10 10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-opacity": ".2",
      "stroke-width": "2",
      d: "m11.414.707-10 10 10 10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-opacity": ".2",
      "stroke-width": "2",
      d: "m11.414.707-10 10 10 10"
    }, null, -1)
  ]))]))
}
export default { render: render }